import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "ma-2" }
const _hoisted_2 = { style: {"font-size":"18px"} }
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_DialogComponent = _resolveComponent("DialogComponent")!

  return (_openBlock(), _createBlock(_component_DialogComponent, {
    onClose: _ctx.close,
    modelValue: _ctx.showConfirmationDialog,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showConfirmationDialog) = $event))
  }, {
    header: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t("titles.confirmMessage")), 1)
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t(_ctx.active ? "subjectsDeactivate" : "subjectsActivate")), 1)
      ]),
      (_ctx.checkActiveSubjects())
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_v_checkbox, {
              class: "mt-1 px-2",
              "hide-details": "auto",
              color: "primary",
              "model-value": _ctx.selectedSubjects.length === _ctx.subjects.length,
              "onUpdate:modelValue": _ctx.selectAll,
              label: _ctx.$t('ALL')
            }, null, 8, ["model-value", "onUpdate:modelValue", "label"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subjects, (subject, index) => {
              return (_openBlock(), _createBlock(_component_v_checkbox, {
                key: index,
                class: "mt-0 px-2",
                "hide-details": "auto",
                color: "primary",
                modelValue: _ctx.selectedSubjects,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedSubjects) = $event)),
                value: subject.id,
                label: subject.name
              }, null, 8, ["modelValue", "value", "label"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    actions: _withCtx(() => [
      _createVNode(_component_v_btn, {
        id: "courseDeactivateDialog-btn-confirm",
        class: "mx-1 success",
        disabled: _ctx.checkSelected(),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activateCourse()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("buttons.confirm")), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_v_btn, {
        id: "courseDeactivateDialog-btn-cancel",
        class: "mx-1",
        color: "secondary",
        variant: "flat",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (!_ctx.active ? _ctx.activateCourse(false) : _ctx.close()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("buttons.cancel")), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onClose", "modelValue"]))
}